import { withInstall } from '@ll-plus/utils'

import Textarea from './src/textarea.vue'

export const LlTextarea = withInstall(Textarea)

export default LlTextarea

export * from './src/textarea'

declare module 'vue' {
  export interface GlobalComponents {
    LlTextarea: typeof Textarea
  }
}
